<template>
  <div class="weui-dialog_alert fix-ios-fixed" @touchmove="onTouchMove" v-show="currentValue">
    <transition :name="maskTransition">
      <div class="weui-mask" @click="onMaskClick" v-show="currentValue"></div>
    </transition>
    <input style="display:none" v-model="currentValue">
    <transition :name="dialogTransition">
      <div class="weui-dialog" v-show="currentValue" >
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'y-dialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'yxy-fade'
    },
    dialogTransition: {
      type: String,
      default: 'yxy-dialog'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    scroll: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      currentValue: false
    }
  },
  watch: {
    value (val) {
      this.currentValue = val
    },
    currentValue (val) {
      this.$emit(val ? 'on-show' : 'on-hide')
      this.$emit('input', val)
    }
  },
  created () {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value
    }
  },
  methods: {
    onTouchMove (event) {
      !this.scroll && event.preventDefault()
    },
    onMaskClick () {
      if (this.hideOnBlur) this.currentValue = false
    }
  }
}
</script>
